import type { MouseEvent } from 'react';

import type { DownloadSource } from '../player/player.config';

import classNames from 'classnames';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { DownloadSourcesMenu } from '../download-sources-menu/download-sources-menu';
import { DownloadSourcesMenuButton } from '../download-sources-menu/download-sources-menu-button';

import styles from './top-bar.module.css';

type TopBarProps = {
  isHidden?: boolean;
  logoUrl?: string;
  title?: string;
  downloadSources?: DownloadSource[];
  downloadSourcesMenuOpen?: boolean;
  onDownloadSourcesMenuButtonClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  onDownloadSourcesMenuClose?: () => void;
};

export const TopBar = forwardRef<HTMLDivElement, TopBarProps>(function TopBar(props, ref) {
  const { t } = useTranslation();
  const {
    isHidden,
    logoUrl,
    title,
    downloadSources,
    downloadSourcesMenuOpen,
    onDownloadSourcesMenuButtonClick,
    onDownloadSourcesMenuClose,
  } = props;

  return (
    <div ref={ref} className={classNames(styles.wrapper, { [styles.hidden]: isHidden })} data-testid="top-bar">
      {logoUrl && <img className={styles.logo} src={logoUrl} alt={t('ui.video-logo.alt')} data-testid="video-logo" />}
      {title && (
        <span className={styles.title} data-testid="video-title">
          {title}
        </span>
      )}

      {downloadSources && downloadSources.length > 0 && (
        <div className={styles.downloadSourcesButton}>
          <DownloadSourcesMenuButton isActive={downloadSourcesMenuOpen} onClick={onDownloadSourcesMenuButtonClick} />
          <DownloadSourcesMenu
            options={downloadSources}
            isOpen={downloadSourcesMenuOpen}
            onClose={onDownloadSourcesMenuClose}
          />
        </div>
      )}
    </div>
  );
});
